import {
  CREATE_ACCOUNT_REQUEST,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const createAccountReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ACCOUNT_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_ACCOUNT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case CREATE_ACCOUNT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default createAccountReducer;
